import { Link, useNavigate, useLocation } from 'react-router-dom';
import { BookOpen, Search, Home, Settings, LogOut, PlusCircle } from 'lucide-react';
import axios from 'axios';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Header = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white border-b border-stone-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link
            to="/"
            className="flex items-center gap-2 transition-opacity duration-200 hover:opacity-80"
            data-testid="header-logo"
          >
            <BookOpen className="w-8 h-8 text-primary" strokeWidth={1.5} />
            <span className="text-2xl font-heading font-bold text-primary">Think About Blog</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`flex items-center gap-2 text-sm font-medium transition-colors duration-200 ${
                isActive('/') ? 'text-primary' : 'text-stone-600 hover:text-primary'
              }`}
              data-testid="nav-home"
            >
              <Home className="w-4 h-4" strokeWidth={1.5} />
              Início
            </Link>

            {user && user.email === 'fablucvi@gmail.com' && (
              <>
                <Link
                  to="/admin"
                  className={`flex items-center gap-2 text-sm font-medium transition-colors duration-200 ${
                    isActive('/admin') ? 'text-primary' : 'text-stone-600 hover:text-primary'
                  }`}
                  data-testid="nav-admin"
                >
                  <Settings className="w-4 h-4" strokeWidth={1.5} />
                  Admin
                </Link>

                <Link
                  to="/dashboard"
                  className={`flex items-center gap-2 text-sm font-medium transition-colors duration-200 ${
                    isActive('/dashboard') ? 'text-primary' : 'text-stone-600 hover:text-primary'
                  }`}
                  data-testid="nav-dashboard"
                >
                  <Settings className="w-4 h-4" strokeWidth={1.5} />
                  Dashboard
                </Link>

                <Link
                  to="/create-post"
                  className="flex items-center gap-2 text-sm font-medium text-stone-600 hover:text-primary transition-colors duration-200"
                  data-testid="nav-create-post"
                >
                  <PlusCircle className="w-4 h-4" strokeWidth={1.5} />
                  Novo Post
                </Link>
              </>
            )}
          </nav>

          <div className="flex items-center gap-4">
            {user ? (
              <>
                <Link to="/search" data-testid="search-button">
                  <Button variant="ghost" size="sm" className="rounded-md">
                    <Search className="w-4 h-4" strokeWidth={1.5} />
                  </Button>
                </Link>

                <div className="flex items-center gap-3">
                  <img
                    src={user.picture || 'https://via.placeholder.com/40'}
                    alt={user.name}
                    className="w-8 h-8 rounded-full border-2 border-stone-200"
                    data-testid="user-avatar"
                  />
                  <Button
                    onClick={handleLogout}
                    variant="ghost"
                    size="sm"
                    className="rounded-md"
                    data-testid="logout-button"
                  >
                    <LogOut className="w-4 h-4" strokeWidth={1.5} />
                  </Button>
                </div>
              </>
            ) : (
              <Link to="/login" data-testid="login-link">
                <Button className="rounded-md" data-testid="login-button">
                  Entrar
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;